import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "sp_token";

const http = axios.create({ baseURL: API });
http.interceptors.request.use((config) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const api = {
  getToken: () => localStorage.getItem(TOKEN_KEY),
  setToken: (t) => { if (t) localStorage.setItem(TOKEN_KEY, t); else localStorage.removeItem(TOKEN_KEY); },

  me: async () => (await http.get("/auth/me")).data,
  magicLink: async (email, name) =>
    (await http.post("/auth/magic-link", { email, name, origin: window.location.origin })).data,
  verify: async (token) => (await http.post("/auth/verify", { token })).data,
  googleSession: async (session_id) => (await http.post("/auth/google/session", { session_id })).data,

  propose: async (text) => (await http.post("/flow/propose", { text })).data,

  consultations: async () => (await http.get("/consultations")).data,
  getConsultation: async (id) => (await http.get(`/consultations/${id}`)).data,
  createConsultation: async (payload) => (await http.post("/consultations", payload)).data,
  setClarity: async (id, c2) => (await http.patch(`/consultations/${id}/clarity`, { c2 })).data,
  setRemind: async (id, remind) => (await http.patch(`/consultations/${id}/remind`, { remind })).data,

  seeds: async () => (await http.get("/seeds")).data,
  redeem: async (code) => (await http.post("/seeds/redeem", { code })).data,
  giftSeeds: async (payload) => (await http.post("/seeds/gift", payload)).data,

  journal: async () => (await http.get("/journal")).data,
  addJournal: async (text, ref) => (await http.post("/journal", { text, ref })).data,

  updateProfile: async (payload) => (await http.patch("/profile", payload)).data,
  deleteAccount: async () => (await http.delete("/account")).data,
  lead: async (name, email) => (await http.post("/lead", { name, email })).data,

  downloadExport: async () => {
    const w = window.open("", "_blank");
    try {
      const { token } = (await http.post("/download-token", { purpose: "export" })).data;
      const url = `${API}/privacy/export?token=${encodeURIComponent(token)}`;
      if (w) w.location = url; else window.location.href = url;
    } catch (e) { if (w) w.close(); throw e; }
  },
  downloadPdf: async (id) => {
    const w = window.open("", "_blank");
    try {
      const { token } = (await http.post("/download-token", { purpose: "pdf", cid: id })).data;
      const url = `${API}/consultations/${id}/pdf?token=${encodeURIComponent(token)}`;
      if (w) w.location = url; else window.location.href = url;
    } catch (e) { if (w) w.close(); throw e; }
  },
};
